export const withValidator = (props, validator) => {
    const { value, isDirty } = props;
    const errors = isDirty ? validator(value) : [];
    return {
        ...props,
        errors,
        error: errors[0],
    };
};
//# sourceMappingURL=withValidator.js.map